import { Button } from 'react-bootstrap'
import { useAtom } from 'jotai'

import * as state from '../states'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { MENU } from '../constants'

export const DashboardPage = () => {
	const [tokens, setTokens] = useAtom(state.tokensAtom)
	const [profile, setProfile] = useAtom(state.profileAtom)

	const navigate = useNavigate()
	//TODO: remove redirection after DashboardPage is ready
	useEffect(() => {
		navigate(MENU.offerScope.url)
	}, [])


	const onClick = () => {
		console.log({ tokens, profile })
		setTokens(null)
		setProfile(null)
	}

	return <>
		Dashboard

		<Button onClick={onClick}>Logout</Button>
	</>
}
